var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMergeBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1779350767395,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1685,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402.4 42.912a48 48 0 0 1 48 48v190.48a48 48 0 1 1-96 0V138.912H152.352v738.48H354.4V744.16a48 48 0 0 1 45.2-47.92l2.816-0.08a48 48 0 0 1 48 48v181.232a48 48 0 0 1-48 48H104.32a48 48 0 0 1-48-48V90.912a48 48 0 0 1 48-48h298.08z m-14.656 319.648l79.52 102.416 1.296 1.696 0.64 0.832 1.28 1.648 2.56 3.296 4.88 6.272a48 48 0 0 1-0.8 59.872l-7.552 9.2-1.312 1.6-81.312 99.168a48 48 0 1 1-74.24-60.88l25.872-31.552-107.76 0.032a48 48 0 0 1 0-96h111.168l-26.32-33.888-3.76-4.832a48 48 0 1 1 75.84-58.88zM621.936 42.912a48 48 0 0 0-48 48v190.48a48 48 0 1 0 96 0V138.912H872v738.48H669.952l-0.016-133.232a48 48 0 0 0-45.184-47.92l-2.816-0.08a48 48 0 0 0-48 48v181.232a48 48 0 0 0 48 48H920a48 48 0 0 0 48-48V90.912a48 48 0 0 0-48-48H621.92z m14.672 319.648l-79.52 102.416-1.312 1.696-0.64 0.832-1.28 1.648-2.56 3.296-4.864 6.272a48 48 0 0 0 0.8 59.872l7.552 9.2 1.312 1.6 81.312 99.168a48 48 0 1 0 74.24-60.88l-25.888-31.552 107.776 0.032a48 48 0 0 0 0-96h-111.168l26.32-33.888 3.744-4.832a48 48 0 1 0-75.84-58.88z",
    "p-id": 1686,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeBag);
export default __webpack_public_path__ + "static/media/mergeBag.ae30121403f212b6adaf5ce6415e6d2a.svg";
export { ForwardRef as ReactComponent };